// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2a4qB","left":"styles_left__2zyZ-"};